import { MoreInfoLink } from '../types/moreInfo';

export const moreInfoLinks: MoreInfoLink[] = [
  {
    langName: 'Français',
    langCode: 'fr',
    url: '/brochures/fr.pdf',
  },
  {
    langName: 'Русский',
    langCode: 'ru',
    url: '/brochures/ru.pdf',
  },
  {
    langName: 'Español',
    langCode: 'es',
    url: '/brochures/es.pdf',
  },

  {
    langName: '中文',
    langCode: 'zh',
    url: '/brochures/zh.pdf',
  },
  {
    langName: 'नेपाली गण',
    langCode: 'npi',
    url: '/brochures/npi.pdf',
  },
  {
    langName: 'Somali',
    langCode: 'som',
    url: '/brochures/som.pdf',
  },

  {
    langName: 'زبان فارسی',
    langCode: 'fas',
    url: '/brochures/fas.pdf',
  },
  {
    langName: 'Eesti',
    langCode: 'et',
    url: '/brochures/et.pdf',
  },
  {
    langName: 'Türkçe',
    langCode: 'tur',
    url: '/brochures/tur.pdf',
  },

  {
    langName: 'اَلْعَرَبِيَّةُ',
    langCode: 'ar',
    url: '/brochures/ara.pdf',
  },
  {
    langName: 'کوردی',
    langCode: 'ckb',
    url: '/brochures/ckb.pdf',
  },
  {
    langName: 'Tiếng Việt',
    langCode: 'vi',
    url: '/brochures/vi.pdf',
  },

  {
    langName: 'English',
    langCode: 'en',
    url: '/brochures/en.pdf',
  },
  {
    langName: 'Svenska',
    langCode: 'sv',
    url: '/brochures/sv.pdf',
  },
  {
    langName: 'Suomi',
    langCode: 'fi',
    url: '/brochures/fi.pdf',
  },
  {
    langName: 'Davvisámegiella',
    langCode: 'sme',
    url: '/brochures/sme.pdf',
  },
  {
    langName: 'Українська мова',
    langCode: 'ukr',
    url: '/brochures/ukr.pdf',
  },
];
